<template>
    <div v-if="serialModel.showTimer" class="text-center text-16 text-a-gray-666666 pt-7">
        <div v-if="!isTimeExpired" class=" flex gap-1 justify-center">
            <div>{{lbl.serial.expire_in}}</div>
            <div :style="textStyle">{{displayTime}}</div>
        </div>
        <div v-else>
            {{lbl.serial.code_expired}}
        </div>
    </div>
</template>
<script>
import TimerHelper from '@/helper/TimerHelper.js';

// import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: "SerialTimer",
    // mixins: [LocaleMixin],
    props: {
        serialModel: Object,
        lbl: Object,
        blobConfig: Object
    },
    data: function () {
        return {
            timer: new TimerHelper(),
            displayTime: "",
            isTimeExpired: false,
            textStyle: {
                color : '',
            },
            isUserActive: true,
        };
    },
    created: function () {
        this.initial();
        this.setupTheme();
    },
    beforeUnmount: function() {
        if (this.timer.interval) {
            this.timer.stopTimer();
        }
    },
    methods: {
        initial: function () {
            // this.checkUserActive()
            this.setTimeout()
        },

        setTimeout: function(){
            console.log('call timeout set')
            if (this.timer.interval) {
                this.timer.stopTimer();
            }

            // Get Current time stamp 
            var startTime =  Date.now(); // current date
            var gmtOffset = 7 * 60 * 60 * 1000; // Plus and convert 7 hours to milliseconds
            startTime += gmtOffset;
            const endtime = this.serialModel.expireIn;
            let timeDiffInSecond = Math.floor(endtime - (startTime / 1000))

            if(timeDiffInSecond < 0) {
                this.serialExpired()
                return;
            }

            this.timer.initialTimer(timeDiffInSecond);
            if (this.serialModel.showTimer) {
                this.isTimeExpired = false;
                this.timer.runTimer((display) => {
                    this.displayTime = display;
                }, () => {
                    this.isTimeExpired = true;
                    this.serialExpired();
                });
            }
        },
        serialExpired: function () {
            this.$emit("onSerialExpired");
        },
        setupTheme: function() {
            this.textStyle.color = this.blobConfig.appConfig.blobConfig.text_color
        },
        onStopTime: function(){
            this.timer.stopTimer();
        }
    }
}
</script>
<style lang="scss" scoped>

</style>
